import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormGroup, FormControl, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import { RepairCodeDescriptionOption, RepairCodeExclusionService } from '../../../services/repair-code-exclusion.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-repair-code-exclusion-information',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './repair-code-exclusion-information.component.html',
  styleUrls: ['./repair-code-exclusion-information.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairCodeExclusionInformationComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() isEditMode = false;

  repairCodeOptions: RepairCodeDescriptionOption[] = [];
  repairModeList: string[] = [];
  isLoadingCodes = false;
  isLoadingModes = false;

  constructor(private readonly service: RepairCodeExclusionService) {}

  ngOnInit(): void {
    void this.initializeComponent();
  }

  private async initializeComponent(): Promise<void> {
    await this.loadModes();
    await this.loadRepairCodes();
  }

  onModeChange(event: Event): void {
    const customEvent = event as CustomEvent;
    const selectedMode = customEvent?.detail?.value ?? customEvent?.detail;
    if (selectedMode) {
      this.formGroup.get('repairMode')?.setValue(selectedMode);
    }
  }

  onRepairCodeChange(_: Event): void {
    const repairCodeControl = this.formGroup.get('repairCode');
    const selectedCode = String(repairCodeControl?.value ?? '').trim().toUpperCase();
    if (!selectedCode) {
      this.formGroup.get('description')?.setValue('');
      return;
    }
    repairCodeControl?.setValue(selectedCode);
    const option = this.repairCodeOptions.find((x) => x.key === selectedCode);
    this.formGroup.get('description')?.setValue(option?.value ?? '');
  }

  private async loadRepairCodes(): Promise<void> {
    this.isLoadingCodes = true;
    try {
      this.repairCodeOptions = await firstValueFrom(this.service.getAllCodes());
    } catch {
      this.repairCodeOptions = [];
    } finally {
      this.isLoadingCodes = false;
    }
  }

  private async loadModes(): Promise<void> {
    this.isLoadingModes = true;
    try {
      const modes = await firstValueFrom(this.service.getAllModes());
      this.repairModeList = modes || [];
    } catch {
      this.repairModeList = [];
    } finally {
      this.isLoadingModes = false;
    }
  }

  isControlInErrorState(control: FormControl | AbstractControl | null | undefined): boolean | null {
    if (control?.invalid && control.touched) {
      return true;
    }
    return null;
  }
}
